import { render, staticRenderFns } from "./TOOL_COMPANY_ADD_EDIT.vue?vue&type=template&id=5b8700a8&scoped=true"
import script from "./TOOL_COMPANY_ADD_EDIT.vue?vue&type=script&lang=ts"
export * from "./TOOL_COMPANY_ADD_EDIT.vue?vue&type=script&lang=ts"
import style0 from "./TOOL_COMPANY_ADD_EDIT.vue?vue&type=style&index=0&id=5b8700a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8700a8",
  null
  
)

export default component.exports